export default "__VITE_ASSET__D25WRmyc__"